// C:\Users\EYG\fynwise-website\src\app\pricing\page.tsx
"use client";

import { useState } from "react";
import Header from "./components/header";
import BillingToggle from "./components/billing-toggle";
import PricingCards from "./components/pricing-cards";
import FeatureComparison from "./components/feature-comparison";
import PricingCTA from "./components/pricing-cta";
import { GridBackground } from "@/components/ui/grid-background";

export default function PricingPage() {
  const [isAnnual, setIsAnnual] = useState(true);

  return (
    <div className="relative min-h-screen bg-black text-white overflow-hidden pt-20 sm:pt-40">
      {/* The grid background needs to be a direct child of the container with proper positioning */}
      <GridBackground />
      
      <div className="container mx-auto text-center relative z-10 mb-10 px-4">
        <Header />
        <BillingToggle isAnnual={isAnnual} setIsAnnual={setIsAnnual} />
        <PricingCards isAnnual={isAnnual} />
        <FeatureComparison />
        <PricingCTA />
      </div>
    </div>
  );
}